import { render, staticRenderFns } from "./ui-picker.vue?vue&type=template&id=052043fc&scoped=true"
import script from "./ui-picker.vue?vue&type=script&lang=js"
export * from "./ui-picker.vue?vue&type=script&lang=js"
import style0 from "./ui-picker.vue?vue&type=style&index=0&id=052043fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052043fc",
  null
  
)

export default component.exports